var jquery = require("jquery");
window.$ = window.jQuery = jquery;
var webfont = require("webfontloader");
window.WebFont = webfont;
